export default __webpack_public_path__ + "static/media/avatar_13.3ed62836.svg";